import {groupBy} from 'lodash';
import RoundingUtility, {RoundingEntities} from '../../../../forecast-app/shared/util/RoundingUtil';
import {hasFeatureFlag} from '../../../../forecast-app/shared/util/FeatureUtil';

export const groupByProperties = (expenses, groupByPropertyList) => {
	groupByPropertyList = groupByPropertyList.slice(0);
	const groupByProperty = groupByPropertyList.shift();
	const groupedExpenses = groupBy(expenses, groupByProperty);
	if (groupByPropertyList.length > 0) {
		Object.keys(groupedExpenses).forEach(groupByValue => {
			groupedExpenses[groupByValue] = groupByProperties(groupedExpenses[groupByValue], groupByPropertyList);
		});
	}
	return groupedExpenses;
};

export const visitGroups = (groups, visitor, groupKeys = []) => {
	if (Array.isArray(groups)) {
		visitor(groups, groupKeys);
	} else if (typeof groups === 'object') {
		Object.keys(groups).forEach(groupKey => {
			const newGroupKeys = groupKeys.slice(0);
			newGroupKeys.push(groupKey);
			visitGroups(groups[groupKey], visitor, newGroupKeys);
		});
	}
};

export const formatDate = (intl, date) => {
	return intl.formatDate(date.startOf('day'), {
		year: 'numeric',
		month: 'short',
		day: 'numeric',
	});
};

export function getExchangeRateOnDate(edges, currency, invoiceDateStr) {
	const rates = edges
		.map(edge => edge.node)
		.filter(node => node.currency === currency)
		.sort((a, b) => {
			if (!a.startDate) return -1;
			if (!b.startDate) return 1;
			return a.startDate.localeCompare(b.startDate);
		});

	let effectiveRate;
	for (const rate of rates) {
		if (!rate.startDate || rate.startDate <= invoiceDateStr) {
			effectiveRate = rate.rate;
		}
	}
	return effectiveRate;
}

export function getCurrentDisplayRate(edges, currency) {
	const today = new Date().toISOString().slice(0, 10);
	return getExchangeRateOnDate(edges, currency, today);
}

export const convertPriceToInvoiceCurrency = (price, sourceCurrency, company, invoice) => {
	let priceInInvoiceCurrency;
	const hasRateRounding = hasFeatureFlag('rate_rounding');

	const edges = company.dateEffectiveExchangeRates?.edges ?? [];
	const invoiceDateStr = invoice?.date?.format?.('YYYY-MM-DD') ?? null;

	const getRate = currency => {
		if (invoiceDateStr && edges.length > 0) {
			const dated = getExchangeRateOnDate(edges, currency, invoiceDateStr);
			if (dated != null) return dated;
		}
		return edges
			.map(e => e.node)
			.filter(n => n.currency === currency)
			.sort((a, b) => (!b.startDate ? 1 : !a.startDate ? -1 : b.startDate.localeCompare(a.startDate)))[0]?.rate;
	};

	if (sourceCurrency !== invoice.currency) {
		let priceInCompanyCurrency;
		if (sourceCurrency !== company.currency) {
			priceInCompanyCurrency = price / getRate(sourceCurrency);
		} else {
			priceInCompanyCurrency = price;
		}

		if (invoice.currency !== company.currency) {
			priceInInvoiceCurrency = priceInCompanyCurrency * getRate(invoice.currency);
		} else {
			priceInInvoiceCurrency = priceInCompanyCurrency;
		}
	} else {
		priceInInvoiceCurrency = price;
	}

	return hasRateRounding
		? RoundingUtility.roundBasedOnEntityType(priceInInvoiceCurrency, RoundingEntities.RATE.name)
		: Math.round(priceInInvoiceCurrency * 100) / 100;
};

export const addQuantityDecimals = (value, company) => {
	return value.toFixed(company.invoiceQuantityDecimals || 2);
};
